module.exports = {
    title: 'Shanki Invoice'
}